<template>
<img src="@/assets/img/login/finger-pointer.png" class="finger-pointer"  >
<router-view v-if="isCustomPage"/>
<div v-if="!isCustomPage">
    <LoadingSpinner v-if="$store.state.isLoading"/>
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — showSidenav state 제거, isCustomPage 단일 조건으로 통합 -->
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 — sidenavOpen reactive로 모바일 토글 (.active CSS 펼침) -->
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase B — sidenavClasses computed로 close 애니메이션 + mount flash 방지 (D-4) -->
    <sidenav :class="sidenavClasses" v-if="!isCustomPage" />
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-HEADER-LAYOUT-001 — 데스크탑 헤더 (REQ-LAYOUT-FE-007) -->
    <!-- v-if="!isCustomPage" 외부 div에 이미 감싸여 있어 별도 v-if 불필요 -->
    <app-header />
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 — v-if 라우트 → CSS viewport 분기 위임 (sidenavbar.scss 172) -->
    <div class="mobile_header" v-if="!isCustomPage">
        <img src="../src/assets/img/certilogo.png"  />
        <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-HEADER-LAYOUT-001 — mobile_header-right 래퍼: LocaleSwitcher + 햄버거 (REQ-LAYOUT-FE-009) -->
        <div class="mobile_header-right">
            <locale-switcher />
            <button id="callSideNav" type="button" @click="$store.commit('toggleSidenav')">
                <i class="fa-regular fa-bars" />
            </button>
        </div>
    </div>
    <main class="main-content position-relative max-height-vh-100 h-100">
        <!-- @MX:NOTE: [AUTO] SPEC-CHINA-GLOBAL-RANDOMNO-BANNER-001 — 앱 전역 난수 미입력 안내 배너.
             main-content 첫 자식으로 둬 기존 헤더 padding-top(60px)을 그대로 활용한다. -->
        <!-- PascalCase 태그 필수: kebab-case로 쓰면 GlobalMissingRandomnoBanner로 역변환되어
             컴포넌트 해석에 실패한다(빌드는 통과, 런타임에 조용히 미렌더). -->
        <GlobalMissingRandomNoBanner />
        <router-view v-if="!isCustomPage"/>
    </main>
</div>

</template>
<script>
import Sidenav from './views/components/Sidenav';
import LoadingSpinner from '@/views/components/Loading.vue';
import AppHeader from '@/components/header/AppHeader.vue';
import LocaleSwitcher from '@/components/header/LocaleSwitcher.vue';
import GlobalMissingRandomNoBanner from '@/components/GlobalMissingRandomNoBanner.vue';
import { 
    oneBtnDialog, 
    resetWrongTokens, 
} from './utils/utils';
import { bridges } from '@/utils/bridges';
import { isPublicRoutePath } from '@/router/publicRoutes';
// 채널톡(한국 상담 위젯) 비활성 — 중국 맥락에 맞는 상담 채널로 교체 예정이라 제거하지 않고 주석 유지.
// import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { decrypt } from '@/utils/crypto';
import { jwtDecoder } from '@/utils/utils';
import chinaInapi from '@/apis/chinaInapi';
// @MX:NOTE: [AUTO] SPEC-CHINA-INAPI-COMPANIES-PRIVILEGES-001 B4 — 자동로그인 /companies 호출 chinaInapi로 전환


// import { ConfigProvider } from 'ant-design-vue';

export default {
    name: 'App',
    setup() {
        const antDesignConfig = {
            form: {
                colon: false,
            }
        }
        return {
            antDesignConfig
        }
    },
    components: {
        Sidenav,
        LoadingSpinner,
        AppHeader,
        LocaleSwitcher,
        GlobalMissingRandomNoBanner,
        // ConfigProvider,
    },
    data() {
        return {
            isInternetConnected: true,
            role: 'MANUFACTURER',
            pollingTimer: null,
            interval: process.env.NODE_ENV === 'production' ? 3600000 : 60000,
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase B — 사이드바 첫 toggle 감지 (close 애니메이션 mount flash 방지)
            //   초기 마운트 시 sidenavOpen=false라 :class에 'close'가 즉시 붙으면 ani2 animation flash 발생.
            //   사용자가 한 번이라도 toggle한 후에만 'close' 클래스 부착 → 닫힘 애니메이션 정상.
            hasInteractedSidenav: false,
        };
    },
    created() {
        console.log('created')
        console.log('App.vue Referrer:', document.referrer);
        resetWrongTokens();

        // 자동 로그인 체크 및 처리
        this.checkAndHandleAutoLogin();

        // 채널톡(한국 상담) 플로팅 버튼 비활성 — 운영자 지시(2026-07-27).
        // 중국 맥락에 맞는 상담 수단으로 다시 붙일 예정이라 삭제하지 않고 주석으로 남긴다.
        // ChannelService.loadScript()
        // ChannelIO('boot', {"pluginKey": process.env.VUE_APP_CHANNEO_IO_PLUGINKEY});
        this.setLiveVersionObserver();

        if (localStorage.getItem('accessTokenManu')) {
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — root 인자 제거, catch로 i18n dialog 위임
            this.$store.dispatch('getCompanyInfo').catch(async () => {
                await oneBtnDialog(this.$t('get_comanyinfo_error_title'), this.$t('get_comanyinfo_error_content'), false);
            });
        }
        window.addEventListener('storage', this.handleStorageChange);

    },
    beforeUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    },
    beforeMount(){
    },
    async mounted() {
        const thisObj = this;
        this.initBridges();
        this.checkHasAccessToken();
        this.setOnlineObserver();
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });
        window.addEventListener('keydown', (event) => {
            // Page Up (33), Page Down (34), End (35), Home (36), Arrow keys (37-40), Space (32)
            if ([32, 33, 34, 35, 36, 37, 38, 39, 40].includes(event.keyCode)) {
                if(thisObj.$store.state.isLoading === true){
                    event.preventDefault();
                }
            }
        });
        function preventScroll(event) {
            if(thisObj.$store.state.isLoading === true){
                event.preventDefault();
            }
        }
    },
    computed: {
        isCustomPage() {
            const specialRoutes = ['/mobile', '/signin'];
            // 공개 授权 페이지(/wx-authorize/*)는 사이드바·헤더 없는 단독 레이아웃
            return specialRoutes.includes(this.$route.path.toLowerCase()) || isPublicRoutePath(this.$route.path);
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase B — close 애니메이션 + mount flash 방지 (D-4)
        //   - sidenavOpen=true → 'active' (펼침 ani 0.5s)
        //   - sidenavOpen=false + hasInteractedSidenav=true → 'close' (닫힘 ani2 0.5s)
        //   - sidenavOpen=false + hasInteractedSidenav=false → '' (초기 마운트, animation 미발동)
        sidenavClasses() {
            const isOpen = this.$store.state.sidenavOpen;
            if (isOpen) return ['fixed-start', 'active'];
            if (this.hasInteractedSidenav) return ['fixed-start', 'close'];
            return ['fixed-start'];
        },
    },
    watch:{
        "$route": {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.currentPageName = newValue.fullPath
                // @MX:NOTE: SPEC-CHINA-ADMIN-LOCALE-CORE-001 — boot locale 적용은 main.js + store/locale.applyLocale 단일 진입점으로 이관 (setLocale 제거)
                // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 — 라우트 변경 시 모바일 사이드바 자동 close
                //   데스크탑은 CSS가 항상 표시라 영향 0. 모바일에서 메뉴 click 후 페이지 이동 시 UX 자동.
                this.$store.commit('closeSidenav');
            },
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase B — 첫 toggle 감지 (close 애니메이션 활성화)
        //   sidenavOpen이 true가 되는 첫 시점에 hasInteractedSidenav=true로 표시.
        //   이후 닫힘 시점부터 'close' 클래스가 부착되어 ani2 닫힘 애니메이션 정상 발동.
        "$store.state.sidenavOpen": {
            handler(newVal) {
                if (newVal && !this.hasInteractedSidenav) {
                    this.hasInteractedSidenav = true;
                }
            },
        },
    },
    methods: {
        handleStorageChange(event) {
            if(event.key === 'manufacturerNameManu') {
                if(event.newValue) {
                    window.location.reload();
                }
            }
            if (event.key === 'accessTokenManu') {
                if (!event.newValue) {
                    window.location.reload();
                }
            }
        },
        // setLocale() 메서드는 SPEC-CHINA-ADMIN-LOCALE-CORE-001에서 제거됨.
        //   - boot locale: main.js (localStorage 'admin_china_locale' 우선)
        //   - 로그인 후 locale: signInMixin 응답 수신 후 store dispatch('locale/applyLocale')
        //   - 변경: 헤더 LocaleSwitcher / /info LocaleSection 둘 다 동일 dispatch
        //   - 옛 키 'locale' + 옛 legacy this.$i18n.locale 할당 패턴 모두 폐기 (REQ-FE-008 단일 진입점)
        initBridges() {
            window.appToWeb = bridges().appToWeb;
            window.webToApp = bridges().webToApp;
            window.checkIsLoggedIn = bridges().checkIsLoggedIn;
            window.requestLogoutFromApp = bridges().requestLogoutFromApp;
        },
        async setLiveVersionObserver() {
            await this.getLiveVersion();

            if(!this.isInternetConnected) return;
            if(this.pollingTimer) return;

            this.pollingTimer = setInterval(async () => {
                if(!this.isInternetConnected) {
                    clearInterval(this.pollingTimer);
                    return;
                }
                await this.getLiveVersion();
            }, this.interval);
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-VER-LOCAL-001 — frontend self-contained version polling
        //   inapi /webversions/live/:serviceType 의존 제거.
        //   build 시 scripts/gen-version.js가 dist/version.json 생성 (git short SHA + builtAt).
        //   같은 SWA origin의 /version.json fetch (Cache-Control: no-cache) → 외부 호출 0.
        //
        //   reload 트리거 규칙:
        //     - localStorage가 비어있음(첫 방문) → reload 안 함, version만 기록
        //       (사용자가 이미 최신 build를 받았으므로 reload 불필요. 매 첫 방문마다 즉시
        //        새로고침되는 UX 거슬림 방지)
        //     - localStorage 값 != fetch 값 (polling 중 새 build 감지) → reload(true)
        async getLiveVersion() {
            try {
                // cache-busting query + no-cache header 이중 방어
                const response = await fetch(`/version.json?_=${Date.now()}`, {
                    cache: 'no-cache',
                    credentials: 'omit',
                });
                if(!response.ok) throw new Error(`version.json HTTP ${response.status}`);
                const data = await response.json();
                if(!data || !data.version) throw new Error('version.json missing version field');

                const stored = localStorage.getItem('currentVersionManu');
                if(stored === null) {
                    // 첫 방문 — 사용자가 이미 최신 build를 받음. 기록만, reload 없음.
                    localStorage.setItem('currentVersionManu', data.version);
                } else if(stored !== data.version) {
                    // polling 중 새 build 감지 — 신규 deploy 반영을 위해 강제 새로고침
                    localStorage.setItem('currentVersionManu', data.version);
                    window.location.reload(true);
                }
            } catch (error) {
                console.log(error);
            }
        },
        checkHasAccessToken() {
            if(localStorage.getItem('accessTokenManu')) {
                window.checkIsLoggedIn({
                    isLoggedIn:true,
                    accessToken:localStorage.getItem('accessTokenManu'),
                    refreshToken:localStorage.getItem('refreshTokenManu'),
                });
            } else {
                window.checkIsLoggedIn({
                    isLoggedIn:false,
                    accessToken:null,
                    refreshToken:null,
                });
            }
        },
        setOnlineObserver() {
            window.addEventListener('online', ()=>{ 
                this.checkIsOnline(true);
            });
            window.addEventListener('offline', ()=>{
                this.checkIsOnline(false);
            });
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-INAPI-AUTH-002 B6 — checkIsIpValid 메서드 제거 (dead code)
        //   호출처 0건 + isIpValid data 필드 미선언 + axios import 없는 상태에서 정의만 있던 dead code였음.
        //   /auth/nation/filter 도 china-inapi 이관 안 함 (Option N-B removal).
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 — toggleSidenav 메서드 제거
        //   기존 document.querySelector('.navbar-vertical...') 셀렉터는 매치 DOM 0건이라 무동작 + null guard 없는 잠재 TypeError.
        //   store mutation toggleSidenav로 대체 (button @click에서 직접 commit). DOM 조작 0건(Phase 1~4 정리 답습).
        async checkIsOnline(isOnline) {
            if(isOnline) {
                this.isInternetConnected = true;
                this.setLiveVersionObserver();
            } else {
                this.isInternetConnected = false;
                if(this.pollingTimer) {
                    clearInterval(this.pollingTimer);
                }
                await oneBtnDialog(this.$t('common_no_internet_connection_title'), this.$t('common_no_internet_connection_content'), false);
            }
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDENAV-REACTIVE-001 — handleDeviceChange 빈 메서드 제거, mediaQuery addListener 8줄 제거 (dead DOM 조작)
        getRoute() {
            const routeArr = this.$route.path.split('/');
            return routeArr[1];
        },
        async checkAndHandleAutoLogin() {
            try {
                // 1. referrer 체크
                console.log('Checking referrer:', document.referrer);
                console.log('Trusted domain:', process.env.VUE_APP_TRUSTED_DOMAIN);
                
                if (!document.referrer.includes(process.env.VUE_APP_TRUSTED_DOMAIN)) {
                    console.log('Referrer not matched');
                    return;
                }
                
                // 2. 로그인 토큰 체크
                if (localStorage.getItem('accessTokenManu')) {
                    console.log('Already logged in');
                    return;
                }
                
                // 3. 직접 로그인 처리
                console.log('Attempting auto login...');
                const decryptedPassword = decrypt(process.env.VUE_APP_AUTO_LOGIN_PASSWORD);

                // @MX:NOTE: [AUTO] SPEC-CHINA-INAPI-AUTH-002 B3 — 자동로그인 /auth/login 호출 chinaInapi로 전환
                const response = await chinaInapi.post('/auth/login', {
                    username: process.env.VUE_APP_AUTO_LOGIN_USERNAME,
                    password: decryptedPassword,
                    role: 'MANUFACTURER'
                });

                if (response.status === 200 || response.status === 201) {
                    // 토큰 저장
                    localStorage.setItem('accessTokenManu', response.data.accessToken);
                    localStorage.setItem('refreshTokenManu', response.data.refreshToken);
                    
                    // 로그인 상태 체크 함수 호출
                    window.checkIsLoggedIn({
                        isLoggedIn: true,
                        accessToken: response.data.accessToken,
                        refreshToken: response.data.refreshToken,
                    });

                    // SPEC-CHINA-ADMIN-LOCALE-CORE-001 REQ-FE-004: 자동로그인 응답 locale 즉시 적용
                    // 우선순위 account.locale > company.locale > 'zh', enum whitelist 적용은 store에서 처리
                    try {
                        await this.$store.dispatch('locale/applyLocale', {
                            source: 'login',
                            payload: {
                                account: response.data.account,
                                company: response.data.company,
                            },
                        });
                    } catch (e) {
                        console.warn('[locale] auto-login applyLocale failed:', e);
                    }

                    // CompanyInfo 가져오기
                    try {
                        const companyId = jwtDecoder(response.data.accessToken);
                        const companyResponse = await chinaInapi.get(`/companies/${companyId}`);
                        
                        if (companyResponse.status === 200 || companyResponse.status === 201) {
                            const { data } = companyResponse;
                            localStorage.setItem('CompanyInfo', JSON.stringify(data));
                            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — root 인자 제거, try/catch로 i18n dialog 위임
                            try {
                                await this.$store.dispatch('getCompanyInfo');
                            } catch (error) {
                                console.log(error);
                                await oneBtnDialog(this.$t('get_comanyinfo_error_title'), this.$t('get_comanyinfo_error_content'), false);
                            }
                        }
                    } catch (error) {
                        console.error('Failed to get company info:', error);
                        throw error;
                    }

                    // 로그인 성공 후 리다이렉트
                    console.log('Auto login successful');
                    this.$router.push('/follower/list');
                }
                
            } catch (error) {
                console.error('Auto login process failed:', error);
                // 에러 발생 시 토큰과 회사 정보 제거
                localStorage.removeItem('accessTokenManu');
                localStorage.removeItem('refreshTokenManu');
                localStorage.removeItem('CompanyInfo');
                // 실패 시 로그인 페이지로 이동
                this.$router.push('/signin');
            }
        },
    },
};
</script>
<style>
.signin-container .carousel__pagination-button::after {
  border-radius: 50% ;
  overflow: hidden ;
  width: 10px ;
  height: 10px ;
}

.finger-pointer{
    position: fixed;
    bottom: 50px;
    right: 70px;
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
}

/* Popconfirm 버튼을 가로 정렬하기 위한 전역 스타일 추가 */
body .ant-popconfirm .ant-popconfirm-buttons {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
}

body .ant-popconfirm .ant-popconfirm-buttons .ant-btn {
  margin-left: 8px !important;
  margin-top: 0 !important;
}

body .ant-popconfirm .ant-popconfirm-buttons .ant-btn:first-child {
  margin-left: 0 !important;
}
</style>

/* SPEC-CHINA-ADMIN-HEADER-LAYOUT-001 — 데스크탑 main 상단 여백 (AppHeader 60px 확보) */
/* REQ-LAYOUT-FE-011: main.main-content padding-top: 60px (≥768px) */
<style scoped>
@media (min-width: 768px) {
  main.main-content {
    padding-top: 60px;
  }
}
</style>
